<template>
  <div class="mt-2 p-2" style="background-color:white;padding:10px">
    <b-container fluid class="mb-2">
      <user-details :userDetails="userDetails"></user-details>
      <div v-if="userType == 'Customer'">
        <user-plots :customerPlotDetails="customerPlotDetails"></user-plots>
      </div>
      <div v-if="userType == 'Agronomists'">
        <operation-team-plots :customerPlotDetails="customerPlotDetails"></operation-team-plots>
      </div>
      <h4 class="text-uppercase font-weight-bold" v-if="userType == 'Customer'">
        Total Credits:
        <span class="text-success">{{ userDetails.TotalCredits }} </span>
      </h4>
    </b-container>
  </div>
</template>
<script>
import userDetails from "@/components/users/details";
import userPlots from "@/components/users/plots/list";
import operationTeamPlots from '@/components/users/plots/operationTeam.vue'

export default {
  components: {
    userDetails,
    userPlots,
    operationTeamPlots
  },
  data() {
    return {
      userDetails: false,
      customerPlotDetails: false,
      userType:'',
    };
  },
  mounted() {
    this.getUserDetails();
    this.getUserPlotDetails();
  },
  methods: {
    getUserDetails() {
     
      let id = this.$route.params.id;
      window.axios.get("user/" + id).then((resp) => {
        this.userDetails = resp.data.data;
        this.userType = resp.data.data._userTypeID.name
      });
    },
    getUserPlotDetails() {
      let id = this.$route.params.id;
      window.axios.get("/customer-plots/" + id).then((resp) => {
        console.log(resp);
        this.customerPlotDetails = resp.data.data;
      });
    },
  },
};
</script>
